import { createSelector } from 'reselect'

// const stateSelector = state => state
const timesheetSelector = state => state.get('timesheet')

export const isFetching = createSelector(
  timesheetSelector,
  timesheetImmutable => {
    const timesheet = timesheetImmutable.toJS()
    return (timesheet.myTimesheetGet.isFetching
  || timesheet.timesheetGet.isFetching
  || timesheet.timesheetByProjectsGet.isFetching
  || timesheet.timesheetStatusGet.isFetching
  || timesheet.timesheetRequestGet.isFetching
  || timesheet.timesheetEdit.isFetching
  || timesheet.timesheetSubmit.isFetching
  || timesheet.timesheetApprove.isFetching
  || timesheet.timesheetExport.isFetching)
  }
)
export const getMyTimesheetData = createSelector(
  timesheetSelector,
  timesheetImmutable => {
    const timesheet = timesheetImmutable.toJS()
    return timesheet.myTimesheetGet
  }
)
export const getInvalidInputData = createSelector(
  timesheetSelector,
  timesheetImmutable => {
    const timesheet = timesheetImmutable.toJS()
    return timesheet.myTimesheetSetInvalidInput
  }
)
export const getTimesheetsData = createSelector(
  timesheetSelector,
  timesheetImmutable => {
    const timesheet = timesheetImmutable.toJS()
    return timesheet.timesheetGet
  }
)
export const editTimesheetsData = createSelector(
  timesheetSelector,
  timesheetImmutable => {
    const timesheet = timesheetImmutable.toJS()
    return timesheet.timesheetEdit
  }
)
export const getTimesheetByProjectsData = createSelector(
  timesheetSelector,
  timesheetImmutable => {
    const timesheet = timesheetImmutable.toJS()
    return timesheet.timesheetByProjectsGet
  }
)
export const submitTimesheetData = createSelector(
  timesheetSelector,
  timesheetImmutable => {
    const timesheet = timesheetImmutable.toJS()
    return timesheet.timesheetSubmit
  }
)
export const getTimesheetStatusData = createSelector(
  timesheetSelector,
  timesheetImmutable => {
    const timesheet = timesheetImmutable.toJS()
    return timesheet.timesheetStatusGet
  }
)
export const getTimesheetRequestData = createSelector(
  timesheetSelector,
  timesheetImmutable => {
    const timesheet = timesheetImmutable.toJS()
    return timesheet.timesheetRequestGet
  }
)
export const setRedirectData = createSelector(
  timesheetSelector,
  timesheetImmutable => {
    const timesheet = timesheetImmutable.toJS()
    return timesheet.timesheetRedirect
  }
)
export const approveTimesheetData = createSelector(
  timesheetSelector,
  timesheetImmutable => {
    const timesheet = timesheetImmutable.toJS()
    return timesheet.timesheetApprove
  }
)
export const cancelTimesheetData = createSelector(
  timesheetSelector,
  timesheetImmutable => {
    const timesheet = timesheetImmutable.toJS()
    return timesheet.timesheetCancel
  }
)
export const getExportURL = createSelector(
  timesheetSelector,
  timesheetImmutable => {
    const timesheet = timesheetImmutable.toJS()
    return timesheet.timesheetExport.url
  }
)
export const getExportMyTimesheetURL = createSelector(
  timesheetSelector,
  timesheetImmutable => {
    const timesheet = timesheetImmutable.toJS()
    return timesheet.myTimesheetExport.url
  }
)
export const isOpenManual = createSelector(
  timesheetSelector,
  timesheetImmutable => {
    const timesheet = timesheetImmutable.toJS()
    return timesheet.timesheetManual.isOpen
  }
)
export const getOptionsTimesheetStatus = createSelector(
  timesheetSelector,
  timesheetImmutable => {
    const timesheet = timesheetImmutable.toJS()
    return timesheet.timesheetSetOptions.statusOptions
  }
)
export const redirectLeaveRequest = createSelector(
  timesheetSelector,
  timesheetImmutable => {
    const timesheet = timesheetImmutable.toJS()
    return ({
      redirect: (timesheet.myTimesheetGet.redirect
      || timesheet.timesheetGet.redirect
      || timesheet.timesheetByProjectsGet.redirect
      || timesheet.timesheetStatusGet.redirect
      || timesheet.timesheetRequestGet.redirect
      || timesheet.timesheetEdit.redirect
      || timesheet.timesheetSubmit.redirect
      || timesheet.timesheetApprove.redirect
      || timesheet.timesheetExport.redirect),
      isAuthenticated: (timesheet.myTimesheetGet.isAuthenticated
      || timesheet.timesheetGet.isAuthenticated
      || timesheet.timesheetByProjectsGet.isAuthenticated
      || timesheet.timesheetStatusGet.isAuthenticated
      || timesheet.timesheetRequestGet.isAuthenticated
      || timesheet.timesheetEdit.isAuthenticated
      || timesheet.timesheetSubmit.isAuthenticated
      || timesheet.timesheetApprove.isAuthenticated
      || timesheet.timesheetExport.isAuthenticated),
    })
  }
)




// WEBPACK FOOTER //
// ./src/selectors/timesheet/timesheet-selector.js